import { derived } from "svelte/store";
import locality from "./locality.js";
import { news as newsAt } from "../api/api.js";

const news = derived(locality, ($locality, set) => {
    if (!!$locality) {
        newsAt($locality)
            .then(({ news }) => {
                set({ all: news });
            })
            .catch((error) => {
                console.warn("failed to load news", error.message);
            });
    }

    return {
        isLoading: !!$locality
    };
});

export default news;
